module.exports = __webpack_public_path__ + "img/undraw_edit_photo_2m6o.d44de5a6.svg";